import { render, staticRenderFns } from "./ChartBaseLabel.vue?vue&type=template&id=0c8b0a05&"
import script from "./ChartBaseLabel.vue?vue&type=script&lang=js&"
export * from "./ChartBaseLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports